<div style="display: flex; flex-direction: row; height: 100%;" data-cy="scheduler-operatory-selector-container">
  <div style="width: 300px; flex-basis: 250px; margin-left: 10px; margin-right: 20px; position: relative; top: -4px;" data-cy="scheduler-operatory-location-section">
    Display Operatories:
    @if (locations.length > 0) {
      <tdo-dropdown-v2 placeholder="Location" id="operatory-selector-location"
        [isMultiSelect]="true"
        [isIncludeAll]="true"
        [datasource]="locations" displayProperty="Name" [value]="selectedLocations"
        (selectionChange)="onLocationSelectionChange($event)"
        (closed)="onLocationSelectionChange($event)"
      data-cy="scheduler-operatory-location-dropdown"></tdo-dropdown-v2>
    }
  </div>
  <div class="scheduler-operatory-selector-main" [ngClass]="{'scheduler-operatory-selector-horizontal': operatoryDataModels.length > 12}" data-cy="scheduler-operatory-list">
    @for (model of operatoryDataModels; track model) {
      <div (click)="onOperatoryPillClick(model)" [ngClass]="{'selected': isModelSelected(model), 'deselected': !isModelSelected(model)}" data-cy="scheduler-operatory-item">
        <span [ngClass]="{'textSelected': isModelSelected(model), 'textDeselected': !isModelSelected(model)}" data-cy="scheduler-operatory-name">{{getLocationShortName(model)}}-{{model.OperatoryName}}</span>@if (isModelSelected(model)) {
        <span matTooltip="Disable operatory view" class="selectedIcon" data-cy="scheduler-operatory-remove-button"><lucide-icon name="x-circle" [size]="20" style="font-size: 16px; margin: 0;"></lucide-icon></span>
      }
    </div>
  }
</div>
</div>
